import { useCallback } from "react";
import { money } from "../../../api/periods";
import { reportsApi } from "../../../api/reports";
import { useLoad } from "../shared";

export function PaymentsDashboard({ nonce = 0 }: { nonce?: number }) {
  const { data: d } = useLoad(useCallback(() => reportsApi.dashboard(), [nonce])); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d) return null;
  const tiles: [string, string, string][] = [
    ["unreconciled", "Unreconciled (sent + pending)", money(d.unreconciled_cents)],
    ["outstanding", "Outstanding", money(d.outstanding_cents)],
    ["failed", "Failed – awaiting retry", String(d.failed_awaiting_retry)],
    ["holds", "Open holds", String(d.open_holds)],
    ["overpayments", "Open overpayments", `${d.open_overpayments} · ${money(d.open_overpayment_cents)}`],
    ["oldest", "Oldest unreconciled", d.oldest_unreconciled_days === null ? "—" : `${d.oldest_unreconciled_days} days`],
  ];
  return (
    <div className="space-y-3" data-testid="payments-dashboard">
      <div className="grid gap-3 sm:grid-cols-3 lg:grid-cols-6">
        {tiles.map(([k, l, v]) => (
          <div key={k} className="rounded-sm border border-white/10 bg-surface p-4" data-testid={`paydash-${k}`}>
            <p className="label-caps text-zinc-500">{l}</p>
            <p className="mt-2 font-mono text-lg text-white" data-testid={`paydash-${k}-value`}>{v}</p>
          </div>
        ))}
      </div>
      <div className="flex flex-wrap gap-2 text-xs text-zinc-400">
        <span className="label-caps text-zinc-500">Obligations</span>
        {Object.entries(d.obligation_counts).map(([s, n]) => <span key={s} className="rounded-sm border border-white/10 px-2 py-0.5" data-testid={`paydash-ob-${s}`}>{s}: {n}</span>)}
        <span className="label-caps ml-3 text-zinc-500">Payment records</span>
        {Object.entries(d.payment_counts).map(([s, n]) => <span key={s} className="rounded-sm border border-white/10 px-2 py-0.5" data-testid={`paydash-pay-${s}`}>{s}: {n}</span>)}
      </div>
    </div>
  );
}
